<template>
  <div id="mainWrapper" class="wrapper">
    <notifications></notifications>
    <support-access-banner />
    <dashboard-navbar id="navbar" :type="$route.meta.navbarType"></dashboard-navbar>
    <side-bar id="navbar2" v-if="navItems.length === 0">
      <template #dropdown-list>
        <div class="col-lg-12">
          <b-form-group v-if="currentUserGroup === 1 && companies.length > 1" role="group" class="m-0 has-feedback">
            <base-input class="mt-3 mb-0">
              <b-form-select
                id="companyID"
                v-model="selectedCompany"
                :options="companies"
                name="companyID"
                placeholder="Select Organization"
                class="form-control m-0"
                @change="onCompanyChange($event)">
              </b-form-select>
            </base-input>
          </b-form-group>
          <content-loader
            v-else-if="currentUserGroup === 1"
            :height="46"
            :width="216"
            :speed="1"
            primary-color="#f3f3f3"
            secondary-color="#dce2fc"
            style="margin-top: 10px">
            <rect x="0" y="3.67" rx="0" ry="0" width="216" height="46" />
          </content-loader>
        </div>
      </template>
      <SideBarLoader style="padding-left: 10px; height: 600px; margin-top: -12px" :user-group="currentUserGroup"> </SideBarLoader>
      <template v-if="links.length > 0 && navItems.length > 0" #links-after>
        <ul class="navbar-nav">
          <hr class="my-2" />
          <h6 class="navbar-heading p-0 text-gray">Links</h6>
          <li v-for="(link, index) in links" :key="index" class="nav-item">
            <a class="nav-link" :href="link.link" target="_blank">
              <i v-if="link.iconFileName === ''" class="fas fa-external-link-alt" :style="iconColor"></i>
              <span v-else class="iconImg"><img :src="link.icon" /></span>
              <span class="nav-link-text">{{ link.title }}</span>
            </a>
          </li>
        </ul>
      </template>
    </side-bar>
    <side-bar id="navbar3" v-else-if="!companyLoading">
      <template #dropdown-list>
        <div class="col-lg-12">
          <b-form-group v-if="currentUserGroup === 1 && companies.length > 1" role="group" class="m-0 has-feedback">
            <base-input class="mt-3 mb-0">
              <b-form-select
                id="companyID"
                v-model="selectedCompany"
                :options="companies"
                name="companyID"
                placeholder="Select Organization"
                class="form-control m-0"
                @change="onCompanyChange($event)">
              </b-form-select>
            </base-input>
          </b-form-group>
          <content-loader
            v-else-if="currentUserGroup === 1"
            :height="46"
            :width="216"
            :speed="1"
            primary-color="#f3f3f3"
            secondary-color="#dce2fc"
            style="margin-top: 10px">
            <rect x="0" y="3.67" rx="0" ry="0" width="216" height="46" />
          </content-loader>
        </div>
      </template>
      <template v-for="(item, index) in navItems" slot="links">
        <hr v-if="item.separator" :key="item.id + index" class="my-2" />
        <div v-if="item.spacer && links.length === 0" :key="item.id + index" class="my-8"></div>
        <h6 v-else-if="item.title" :key="item.id + index" class="navbar-heading p-0 text-gray">
          {{ item.name }}
          <span v-if="item.id === 'communityTools'" class="sidebar-new-badge">NEW</span>
        </h6>
        <div v-else-if="item.id === 'communityToolsLaunch'" :key="item.id + index">
          <li class="nav-item">
            <a
              class="sidebar-menu-item nav-link"
              :aria-expanded="!communityToolsCollapsed"
              data-toggle="collapse"
              href="#"
              @click.prevent="toggleCommunityToolsMenu">
              <i :class="item.icon + ' text-primary'" :style="iconColor"></i>
              <span class="nav-link-text">{{ item.name }} <b class="caret"></b></span>
            </a>
            <div v-show="!communityToolsCollapsed" class="collapse show">
              <ul class="nav nav-sm flex-column">
                <li v-for="(subItem, subindex) in item.children" :key="subItem.name + subindex" class="nav-item">
                  <a class="nav-link" href="#" @click.prevent="openCommunityTool(subItem.handoffTool)">
                    <i :class="subItem.icon + ' text-primary'" :style="iconColor"></i>
                    <span class="nav-link-text">{{ subItem.name }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </div>
        <div v-else-if="item.handoffTool" :key="item.id + index">
          <li class="nav-item">
            <a class="nav-link" href="#" @click.prevent="openCommunityTool(item.handoffTool)">
              <i :class="item.icon + ' text-primary'" :style="iconColor"></i>
              <span class="nav-link-text">{{ item.name }}</span>
            </a>
          </li>
        </div>
        <div v-else-if="item.url" :key="item.id + index">
          <sidebar-item
            :link="{
              name: item.name,
              icon: item.icon + ' text-primary',
              path: item.url,
            }"
            :icon-color="iconColor">
          </sidebar-item>
        </div>
        <div v-else :key="index + item.id">
          <sidebar-item
            :link="{
              name: item.name,
              icon: item.icon + ' text-primary',
            }"
            :icon-color="iconColor">
            <div v-if="item.children">
              <sidebar-item
                v-for="(subItem, subindex) in item.children"
                :key="subItem.name + subindex"
                :link="{
                  name: subItem.name,
                  path: subItem.url,
                  icon: subItem.icon + ' text-primary',
                }"
                :icon-color="iconColor" />
            </div>
          </sidebar-item>
        </div>
      </template>
      <template v-if="links.length > 0 && navItems.length > 0" #links-after>
        <ul class="navbar-nav">
          <hr class="my-2" />
          <h6 class="navbar-heading p-0 text-gray">Links</h6>
          <li v-for="(link, index) in links" :key="index" class="nav-item">
            <a class="nav-link" :href="link.link" target="_blank">
              <i v-if="link.iconFileName === ''" class="fas fa-external-link-alt" :style="iconColor"></i>
              <span v-else class="iconImg"><img :src="link.icon" /></span>
              <span class="nav-link-text">{{ link.title }}</span>
            </a>
          </li>
        </ul>
      </template>
    </side-bar>
    <div id="mainContent" :class="mainContentClass">
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <b-modal
      id="browser_warning"
      ref="browser_warning"
      title="Warning"
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      :header-text-variant="'light'"
      hide-footer
      :header-bg-variant="'warning'">
      <div class="p-2 pl-3 w-100 title-temp">
        <h4 class="w-75">Warning</h4>
        <a class="closebtn" @click="closeWarning">×</a>
      </div>
      <div class="body-temp d-block text-center w-100">For best results please use latest version of Chrome browser</div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable no-new */
import Vue from 'vue';
import * as Cookies from 'js-cookie';
import config from 'config';
import { decoder } from '@/utils/sessions/jwt';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import nav from '../_nav';
import { canonicalizeAdminMenu, applySavedAdminMenuNames } from '../utils/adminMenu';
import DashboardNavbar from './DashboardNavbar.vue';
import SupportAccessBanner from '@/components/SupportAccessBanner.vue';
import ContentFooter from './ContentFooter.vue';
import SideBarLoader from '@/components/ContentLoader/SideBarLoader';
import { FadeTransition } from 'vue2-transitions';
import { ContentLoader } from 'vue-content-loader';
import { API_URL, STATIC_URL } from '@/api/constants/baseUrl';
import { NotificationTypes, wrapNotification } from '@/utils/notification';

Vue.use(Cookies);

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  name: 'DashboardLayout',
  components: {
    ContentLoader,
    DashboardNavbar,
    SupportAccessBanner,
    ContentFooter,
    // DashboardContent,
    FadeTransition,
    SideBarLoader,
  },
  data() {
    return {
      messagingOnly: false,
      communityToolsCollapsed: true,
      navItems: [],
      navList: [],
      openingCommunityTool: false,
      staticUrl: STATIC_URL,
    };
  },
  computed: {
    mainContentClass() {
      return this.$router.currentRoute.query.autoLogin ? ' ' : 'main-content';
    },
    companyLoading: {
      get: function () {
        this.initScrollbar();
        return this.$store.state.company.loading;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    profileLoading() {
      return this.$store.state.user.loading || '';
    },
    companies() {
      const companyList = Vue.lodash.filter(this.companyList, { isActive: 1 });
      const data = companyList.map((company) => {
        return { value: company.companyID, text: company.name };
      });

      const companies = data.sort(function (a, b) {
        return a.text.localeCompare(b.text);
      });

      return [{ value: null, text: 'Select Organization' }, ...companies];
    },
    companyList: {
      get: function () {
        return this.$store.state.company.companyList;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    selectedCompany: {
      get: function () {
        return this.$store.state.company.selectedCompany || Cookies.get('companyID') || null;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    currentCompany() {
      return this.$store.state.user.companyID;
    },
    currentUserGroup() {
      return this.$store.state.user.userGroup || null;
    },
    logo() {
      let company = this.$store.state.user.company || null;

      if (this.selectedCompany == null && (company === null || company === '')) {
        return {
          srcDefault: '/img/brand/logo.png',
          nameDefault: 'Vobo',
          titleDefault: 'Vobo',
        };
      } else {
        return {
          src: company !== null ? (typeof company.logo !== 'undefined' ? company.logo : '') : '/img/brand/logo.png',
          name: company !== null ? company.name : '',
          title: company !== null ? company.name : '',
        };
      }
    },
    iconColor: {
      get: function () {
        // console.log(this.$store.state.company.company)
        let adminColor = Cookies.get('adminColor');
        return `color: ${adminColor} !important` || '';
      },
      set: function (newValue) {
        return newValue;
      },
    },
    links: {
      get: function () {
        const isFeaturedLinksEnable = this.$root.$store.state.user.featuredLinks || false;
        const company = this.$root.$store.state.company.company || [];
        const menuFeatureLink = this.$root.$store.state.user.menuFeatureLink;
        var menuLinks = [];
        var settingFeatureLinkItem = {};

        menuLinks = 'featuredLinks' in company && isFeaturedLinksEnable ? company.featuredLinks : [];

        if (Object.keys(menuFeatureLink).length > 0) {
          settingFeatureLinkItem = menuFeatureLink;
          settingFeatureLinkItem.icon = 'fas fa-external-link-alt';
          settingFeatureLinkItem.iconFileName = '';
          settingFeatureLinkItem.menuFeatureLink = true;
        }

        if (menuLinks.length > 0) {
          const isMenuFeatureLinkFound = menuLinks.filter((menu) => {
            return menu.menuFeatureLink === true;
          });

          if (isMenuFeatureLinkFound.length === 0 && Object.keys(settingFeatureLinkItem).length > 0) {
            menuLinks.push(settingFeatureLinkItem);
          }
        } else {
          if (Object.keys(settingFeatureLinkItem).length > 0) {
            menuLinks.push(settingFeatureLinkItem);
          }
        }

        return menuLinks || [];
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  watch: {
    selectedCompany: {
      immediate: true,
      handler(companyID) {},
    },
    $route(to, from) {
      const currentRoute = this.$router.currentRoute;
      const allowedRoutes = [
        'Dashboard',
        'Broadcast Message',
        'Send a Broadcast',
        'Send Message',
        'Broadcast History',
        'Message History',
        'Send a Text (SMS)',
        'Text History',
        // Content Library (current names)
        'Content Library',
        'Content Library List',
        'Upload File',
        'Update File',
        // Legacy names kept so older bookmarks/deploys do not bounce messaging-only admins
        'Wave Management',
        'Video Management',
        'HTML/PDF Files',
        'Upload File List',
        'File Manager',
        'Upload Wave File',
        'Update Wave File',
        'Upload Video File',
        'Update Video File',
        'Upload HTML/PDF File',
        'Update HTML/PDF File',
        'Profile',
      ];

      // Auto-login deep links must not be bounced (nav chrome is hidden via ?autoLogin=).
      if (this.$route.query.autoLogin) {
        return;
      }

      if (this.messagingOnly && !allowedRoutes.includes(currentRoute.name)) {
        this.$router.push('/dashboard');
      }
    },
  },
  mounted() {
    const token = Cookies.get('user-token');
    const browserWarning = Cookies.get('browser-warning');

    const decode = decoder({
      secret: config.secret,
    });

    var payload = decode(token);

    this.loadProfile(payload.userGroup);

    const browserInfo = this.$options.filters.getBrowserInfo();

    if (browserInfo[0] !== 'Chrome' && browserInfo[1] <= 79) {
      if (browserWarning !== '0') {
        this.$bvModal.show('browser_warning');
      }
    }

    const query = this.$router.currentRoute.query;
    const autoLogin = query.autoLogin;
    if (autoLogin) {
      const navBar = document.getElementById('navbar');
      const navBar2 = document.getElementById('navbar2');
      const navBar3 = document.getElementById('navbar3');

      const mainContent = document.getElementById('mainContent');
      navBar.style.display = 'none';
      navBar2.style.display = 'none';
      navBar3.style.display = 'none';
      mainContent.classList.remove('main-content');
    }
  },
  methods: {
    findUploadContentItem(items = this.navItems) {
      const topLevel = items.find((item) => item.id === 'uploadContent');
      if (topLevel) {
        return topLevel;
      }
      const unionLinks = items.find((item) => item.id === 'unionLinks');
      return unionLinks?.children?.find((child) => child.id === 'uploadContent');
    },
    /**
     * Stored company.adminMenu often still has the old nested "Publish Content" (id: unionLinks)
     * parent. Flatten those children to top-level Manage Content items and drop duplicates
     * (especially Upload Content left at an older index).
     */
    normalizeManageContentNav(items) {
      const userGroup = Number(this.currentUserGroup);
      const contentDefaults = ['contentBanners', 'contentBannerTemplates', 'contentLinks', 'uploadContent']
        .map((id) => nav.items.find((item) => item.id === id))
        .filter(Boolean);
      const contentUrls = new Set(contentDefaults.map((item) => item.url));
      const allowedForUser = (def) => {
        if (!userGroup) {
          return true;
        }
        return (def.userGroups || []).map(Number).includes(userGroup);
      };

      items.forEach((item) => {
        if (
          item.title &&
          (item.id === 'Publish Content header' ||
            String(item.name || '').toLowerCase() === 'publish content')
        ) {
          item.name = 'Manage Content';
          item.id = 'Manage Content header';
        }
      });

      const promoted = [];
      for (let i = items.length - 1; i >= 0; i--) {
        const item = items[i];
        const nameKey = String(item.name || '').toLowerCase();
        const isContentParent =
          item.id === 'unionLinks' ||
          (!item.url &&
            Array.isArray(item.children) &&
            item.children.some((child) => contentUrls.has(child.url)) &&
            (nameKey === 'publish content' || nameKey === 'manage content'));

        if (!isContentParent) {
          continue;
        }

        (item.children || []).forEach((child) => {
          promoted.push({ ...child });
        });
        items.splice(i, 1);
      }

      promoted.forEach((child) => {
        if (!child.url || items.some((item) => item.url === child.url)) {
          return;
        }
        const def = contentDefaults.find((entry) => entry.url === child.url);
        if (def && !allowedForUser(def)) {
          return;
        }
        items.push(child);
      });

      // Drop role-restricted content items (e.g. Banner Templates for channel admin)
      for (let i = items.length - 1; i >= 0; i--) {
        const item = items[i];
        const def = contentDefaults.find((entry) => entry.url === item.url || entry.id === item.id);
        if (def && !allowedForUser(def)) {
          items.splice(i, 1);
        }
      }

      contentDefaults.forEach((def) => {
        if (!allowedForUser(def)) {
          return;
        }
        const existing = items.find((item) => item.url === def.url || item.id === def.id);
        if (!existing) {
          items.push({ ...def });
          return;
        }
        existing.id = def.id;
        existing.index = def.index;
        existing.url = def.url;
        existing.icon = existing.icon || def.icon;
        existing.access = existing.access || def.access;
        // Role visibility comes from _nav (e.g. Banner Templates = org/super only).
        existing.userGroups = def.userGroups || existing.userGroups;
        if (!existing.name) {
          existing.name = def.name;
        }
      });

      const seenContentUrls = new Set();
      const deduped = [];
      items.forEach((item) => {
        if (item.url && contentUrls.has(item.url)) {
          if (seenContentUrls.has(item.url)) {
            return;
          }
          seenContentUrls.add(item.url);
          const def = contentDefaults.find((entry) => entry.url === item.url);
          if (def && !allowedForUser(def)) {
            return;
          }
          deduped.push({
            ...item,
            id: def?.id || item.id,
            index: def?.index ?? item.index,
            name: item.name || def?.name,
            icon: item.icon || def?.icon,
            access: item.access || def?.access,
            userGroups: def?.userGroups || item.userGroups,
          });
          return;
        }
        deduped.push(item);
      });

      items.splice(0, items.length, ...deduped);
      return items;
    },
    /**
     * Stored company.adminMenu may still say Messages / Send Message / Message History,
     * and may use old indexes that collide with new Text SMS items (duplicate History).
     * Canonicalize ids/urls/indexes and dedupe by url; preserve org-custom display names
     * (same approach as normalizeManageContentNav). Ensure separator before Manage Content.
     */
    normalizeCommunicationsNav(items) {
      const commDefaults = ['sendMessage', 'sendTextSms', 'messageList', 'textSmsHistory']
        .map((id) => nav.items.find((item) => item.id === id))
        .filter(Boolean);
      const separatorAfterComms = nav.items.find((item) => item.id === 'separator3');
      const renameLegacy = {
        messages: 'Communications',
        'Send Message': 'Broadcast Message',
        'Send a Broadcast': 'Broadcast Message',
        'Message History': 'Broadcast History',
      };
      const urlToId = {
        '/messages/send-notifications': 'sendMessage',
        '/messages/history': 'messageList',
        '/messages/send-text': 'sendTextSms',
        '/messages/text-history': 'textSmsHistory',
      };

      items.forEach((item) => {
        if (item.id === 'messages' || (item.title && String(item.name || '').toLowerCase() === 'messages')) {
          item.id = 'messages';
          if (!item.name || String(item.name).toLowerCase() === 'messages') {
            item.name = 'Communications';
          }
        }
        const byName = renameLegacy[String(item.name || '')];
        if (byName) {
          item.name = byName;
        }
        const canonicalId = urlToId[item.url];
        if (canonicalId) {
          item.id = canonicalId;
        }
      });

      commDefaults.forEach((def) => {
        const existing = items.find((item) => item.id === def.id || item.url === def.url);
        if (!existing) {
          items.push({ ...def });
          return;
        }
        existing.id = def.id;
        existing.url = def.url;
        existing.index = def.index;
        // Keep org-admin custom labels; only fill when missing
        if (!existing.name) {
          existing.name = def.name;
        }
        existing.icon = existing.icon || def.icon;
        existing.access = existing.access || def.access;
        existing.userGroups = existing.userGroups || def.userGroups;
      });

      // Drop stray separators that sit inside the communications block (old index collisions)
      const commIndexes = new Set(commDefaults.map((d) => d.index));
      for (let i = items.length - 1; i >= 0; i--) {
        const item = items[i];
        if (item.separator && item.id !== 'separator3' && commIndexes.has(item.index)) {
          items.splice(i, 1);
        }
      }

      if (separatorAfterComms) {
        // Remove any duplicate separator3 entries, then place one after Text History
        for (let i = items.length - 1; i >= 0; i--) {
          if (items[i].id === 'separator3' || (items[i].separator && items[i].index === separatorAfterComms.index)) {
            items.splice(i, 1);
          }
        }
        items.push({ ...separatorAfterComms });
      }

      const seenUrls = new Set();
      const deduped = [];
      items.forEach((item) => {
        if (item.url && commDefaults.some((def) => def.url === item.url)) {
          if (seenUrls.has(item.url)) {
            return;
          }
          seenUrls.add(item.url);
        }
        deduped.push(item);
      });
      items.splice(0, items.length, ...deduped);

      return items;
    },
    sortVoboSettingsChildren(children) {
      const defaultSettings = nav.items.find((item) => item.id === 'voboSettings' && item.children);
      const childOrder = defaultSettings?.children?.map((child) => child.url || child.id) || [];

      return [...children].sort((a, b) => {
        const keyA = a.url || a.id;
        const keyB = b.url || b.id;
        const orderA = childOrder.indexOf(keyA);
        const orderB = childOrder.indexOf(keyB);
        if (orderA !== -1 && orderB !== -1) {
          return orderA - orderB;
        }
        return (a.index ?? 0) - (b.index ?? 0);
      });
    },
    relocateAdminsMenu(items) {
      const defaultAdmin = nav.items.find((item) => item.id === 'adminUsers');
      const defaultSeparatorBeforeSettings = nav.items.find((item) => item.id === 'separatorBeforeSettings');
      const defaultSeparatorBeforeAdmins = nav.items.find((item) => item.id === 'separatorBeforeAdmins');
      const defaultSeparatorAfterAdmins = nav.items.find((item) => item.id === 'separator4');
      let adminItem = items.find((item) => item.id === 'adminUsers' && item.url);
      const followers = items.find((item) => item.id === 'followers');

      if (!adminItem && followers?.children) {
        const child = followers.children.find((menuItem) => menuItem.id === 'adminUsers');
        if (child) {
          adminItem = { ...child };
        }
      } else if (adminItem) {
        adminItem = { ...adminItem };
      }

      if (!adminItem && defaultAdmin) {
        adminItem = { ...defaultAdmin };
      }

      if (!adminItem) {
        return items;
      }

      if (followers?.children) {
        followers.children = followers.children.filter((menuItem) => menuItem.id !== 'adminUsers');
      }

      ['adminUsers', 'separatorBeforeAdmins', 'separatorBeforeSettings', 'separator4'].forEach((itemId) => {
        const itemIndex = items.findIndex((item) => item.id === itemId);
        if (itemIndex !== -1) {
          items.splice(itemIndex, 1);
        }
      });

      const channelsIndex = items.findIndex((item) => item.id === 'channels');
      if (channelsIndex !== -1) {
        const insertItems = [];
        if (defaultSeparatorBeforeAdmins) {
          insertItems.push({ ...defaultSeparatorBeforeAdmins });
        }
        insertItems.push(adminItem);
        if (defaultSeparatorAfterAdmins) {
          insertItems.push({ ...defaultSeparatorAfterAdmins });
        }
        items.splice(channelsIndex, 0, ...insertItems);
        return items;
      }

      const settingsTitleIndex = items.findIndex((item) => item.id === 'settings' && item.title === true);
      if (settingsTitleIndex === -1) {
        return items;
      }

      const insertItems = [];
      if (defaultSeparatorBeforeAdmins) {
        insertItems.push({ ...defaultSeparatorBeforeAdmins });
      }
      insertItems.push(adminItem);
      if (defaultSeparatorBeforeSettings) {
        insertItems.push({ ...defaultSeparatorBeforeSettings });
      }
      items.splice(settingsTitleIndex, 0, ...insertItems);

      return items;
    },
    relocateMessageSequenceToSettings(items) {
      const defaultSettings = nav.items.find((item) => item.id === 'voboSettings' && item.children);
      const defaultWelcome = defaultSettings?.children?.find((child) => child.id === 'messageSequence');

      let sequenceItem = items.find((item) => item.id === 'messageSequence');
      if (sequenceItem) {
        sequenceItem = { ...sequenceItem, name: 'Welcome Message' };
        items.splice(
          items.findIndex((item) => item.id === 'messageSequence'),
          1,
        );
      }

      if (!sequenceItem && defaultWelcome) {
        sequenceItem = { ...defaultWelcome };
      }

      if (!sequenceItem) {
        return items;
      }

      items.forEach((item) => {
        if (item.id === 'voboSettings' && item.children) {
          const children = item.children.filter((child) => child.id !== 'messageSequence');
          children.push(sequenceItem);
          item.children = children;
        }
      });

      return items;
    },
    removeSubAdminsFromSettings(items) {
      items.forEach((item) => {
        if (item.id === 'voboSettings' && item.children) {
          item.children = item.children.filter((child) => child.id !== 'adminUsers');
        }
      });

      return items;
    },
    isCommunityToolsMenuItem(item) {
      return (
        item.id === 'separatorCommunityToolsBefore' ||
        item.id === 'communityTools' ||
        item.id === 'communityToolsLaunch' ||
        item.handoffTool ||
        String(item.id || '').startsWith('communityTools')
      );
    },
    defaultCommunityToolsItems() {
      const items = nav.items
        .filter((item) => item.id === 'separatorCommunityToolsBefore' || item.id === 'communityTools' || item.id === 'communityToolsLaunch')
        .map((item) => JSON.parse(JSON.stringify(item)));
      const launcher = items.find((item) => item.id === 'communityToolsLaunch');
      if (launcher?.children) {
        const access = this.communityToolsAccess();
        launcher.children = launcher.children.filter((child) => access[child.handoffTool] !== false);
      }
      return launcher?.children?.length === 0 ? [] : items;
    },
    communityToolsAccess() {
      return {
        calendar: false,
        elections: false,
        website: false,
        payments: false,
        assistant: false,
        ...(this.$store.state.user.communityToolsAccess || {}),
      };
    },
    positionCommunityToolsAfterAdmins(items) {
      if (Number(this.currentUserGroup) !== 2) {
        return items;
      }

      for (let i = items.length - 1; i >= 0; i--) {
        if (this.isCommunityToolsMenuItem(items[i])) {
          items.splice(i, 1);
        }
      }

      const communityToolsItems = this.defaultCommunityToolsItems();
      if (communityToolsItems.length === 0) {
        return items;
      }

      const adminIndex = items.findIndex((item) => item.id === 'adminUsers');
      const settingsSeparatorIndex = items.findIndex((item) => item.id === 'separatorBeforeSettings');
      const settingsIndex = items.findIndex((item) => item.id === 'settings');
      const insertAt =
        adminIndex !== -1
          ? adminIndex + 1
          : settingsSeparatorIndex !== -1
            ? settingsSeparatorIndex
            : settingsIndex !== -1
              ? settingsIndex
              : items.length;

      items.splice(insertAt, 0, ...communityToolsItems);
      return items;
    },
    finalizeNavItems(items) {
      this.normalizeManageContentNav(items);
      this.normalizeCommunicationsNav(items);
      this.relocateAdminsMenu(items);
      this.positionCommunityToolsAfterAdmins(items);
      this.relocateMessageSequenceToSettings(items);
      this.removeSubAdminsFromSettings(items);

      items.forEach((item) => {
        if (!item.children?.length) {
          return;
        }
        if (item.id === 'voboSettings') {
          item.children = this.sortVoboSettingsChildren(item.children);
        } else {
          item.children = [...item.children].sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
        }
      });

      items.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
      return items;
    },
    removeGroupManagementMenu(items) {
      items.forEach((item) => {
        if (item.id === 'followers' && item.children) {
          item.children = item.children.filter((child) => child.url !== '/users/groups');
        }
      });

      return items;
    },
    toggleCommunityToolsMenu() {
      this.communityToolsCollapsed = !this.communityToolsCollapsed;
    },
    communityToolsLaunchCompanyId() {
      const fromSelection = String(this.selectedCompany || '').trim();
      const fromUser = String(this.$store.state.user.companyID || '').trim();
      return (fromSelection || fromUser).toLowerCase();
    },
    communityToolsCompanyUrlMap() {
      try {
        const raw = String(process.env.VUE_APP_COMMUNITY_TOOLS_COMPANY_URLS || '').trim();
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
        const map = {};
        Object.keys(parsed).forEach((key) => {
          const companyId = String(key || '').trim().toLowerCase();
          const url = String(parsed[key] || '').trim().replace(/\/+$/, '');
          if (companyId && url) map[companyId] = url;
        });
        return map;
      } catch (_) {
        return {};
      }
    },
    communityToolsBaseUrl() {
      const defaultUrl = String(process.env.VUE_APP_COMMUNITY_TOOLS_URL || '').replace(/\/+$/, '');
      const companyId = this.communityToolsLaunchCompanyId();
      if (!companyId) return defaultUrl;
      return this.communityToolsCompanyUrlMap()[companyId] || defaultUrl;
    },
    openCommunityToolsInNewTab() {
      const target = String(process.env.VUE_APP_COMMUNITY_TOOLS_OPEN_TARGET || '').trim().toLowerCase();
      return target === 'new_tab';
    },
    async openCommunityTool(tool) {
      if (this.openingCommunityTool) {
        return;
      }

      const communityToolsUrl = this.communityToolsBaseUrl();
      if (!communityToolsUrl) {
        wrapNotification(
          this.$notify,
          NotificationTypes.Error,
          '',
          'Community Tools URL is not configured for this environment',
          6000,
        );
        return;
      }

      const token = Cookies.get('user-token');
      if (!token) {
        wrapNotification(this.$notify, NotificationTypes.Error, '', 'Your admin session is missing. Please log in again.', 6000);
        return;
      }

      this.openingCommunityTool = true;
      const shouldOpenNewTab = this.openCommunityToolsInNewTab();
      const handoffWindow = shouldOpenNewTab ? window.open('about:blank', '_blank') : null;
      if (handoffWindow) {
        handoffWindow.opener = null;
        handoffWindow.document.title = 'Opening Community Tools...';
      }

      try {
        const resp = await fetch(`${API_URL}/v1/partner/community-tools/handoff`, {
          method: 'POST',
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ tool }),
        });
        const data = await resp.json().catch(() => ({}));

        if (!resp.ok || !data.ok || !data.handoffToken) {
          throw new Error(data.message || data.error || 'Unable to open Community Tools');
        }

        const url = new URL('/auth/handoff', communityToolsUrl);
        url.searchParams.set('token', data.handoffToken);
        url.searchParams.set('tool', data.tool || tool);

        if (shouldOpenNewTab && handoffWindow && !handoffWindow.closed) {
          handoffWindow.location.href = url.toString();
        } else if (shouldOpenNewTab) {
          window.open(url.toString(), '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = url.toString();
        }
      } catch (error) {
        if (handoffWindow && !handoffWindow.closed) {
          handoffWindow.close();
        }
        wrapNotification(
          this.$notify,
          NotificationTypes.Error,
          '',
          error.message || 'Unable to open Community Tools',
          6000,
        );
      } finally {
        this.openingCommunityTool = false;
      }
    },
    toggleShowUploadVideo() {
      if (this.$root.$store.state.user.userGroup == 1 || this.$root.$store.state.user.userGroup == 4) return;
      if (this.$store.state.user.enablePrivateVideo) return;
      const uploadItem = this.findUploadContentItem();
      if (uploadItem?.children?.length) {
        uploadItem.children = uploadItem.children.filter((item) => item.index !== 1);
      }
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('scrollbar-inner');
      }
    },
    loadProfile(userGroup) {
      if (!this.$store.state.user.profileLoaded || this.navItems.length === 0) {
        this.$store.dispatch('user/USER_PROFILE_REQUEST').then((userProfile) => {
          // if (this.currentUserGroup !== 2) {
          this.$store.dispatch('company/GET_COMPANY_LIST').then((resp) => {
            var companyID = Cookies.get('companyID');
            let company = resp.filter((companyVal) => {
              return companyVal.companyID === companyID;
            });

            this.$store.commit('company/SET_SELECTED_COMPANY', companyID);
            this.$store.commit('company/SET_SELECTED_COMPANY_DETAILS', company[0]);
            this.$root.$store.state.user.companyID = companyID;

            let companyStore = this.$store.state.company.company;
            let faviconIcon = '/favicon.ico';

            if (companyStore === null || companyStore === '' || companyStore === undefined) {
              faviconIcon = '/favicon.ico';
            } else {
              faviconIcon = companyStore.favicon + '?=' + Math.random() || companyStore.logo + '?=' + Math.random();
            }

            var favicon = document.querySelectorAll('.favicon');
            for (var i = 0; i < favicon.length; i++) {
              favicon[i].href = faviconIcon;
            }

            document.title = companyStore ? companyStore.name : 'Vobo';

            if (this.$root.$store.state.user.userGroup == 1) {
              let currentUserCompany = this.$root.$store.state.company.company;
              if (currentUserCompany && (currentUserCompany !== null || currentUserCompany !== undefined)) {
                if (currentUserCompany.hasOwnProperty('adminColor')) {
                  Cookies.set('adminColor', currentUserCompany.adminColor.color_hex);
                  this.iconColor = `color: ${currentUserCompany.adminColor.color_hex} !important`;
                } else {
                  Cookies.set('adminColor', '');
                  this.iconColor = '';
                }
              }
            }

            if (resp && company.length > 0) {
              const savedAdminMenu =
                company[0].hasOwnProperty('adminMenu') && company[0].adminMenu.length > 0
                  ? company[0].adminMenu
                  : [];
              this.navItems = canonicalizeAdminMenu(savedAdminMenu, { userGroup });

              if (this.currentUserGroup === 2) {
                this.navItems.forEach((item) => {
                  if (item.id === 'followers') {
                    const followersSection = nav.items.find((navItem) => navItem.id === 'followers');
                    const imTab = followersSection?.children?.find((child) => child.name === 'IM');
                    if (imTab && !(item.children || []).some((child) => child.name === 'IM' || child.url === imTab.url)) {
                      item.children = [...(item.children || []), { ...imTab }];
                    }
                  }
                });
              }

              this.toggleShowUploadVideo();
              this.navItems = this.finalizeNavItems(this.navItems);
              // Re-apply custom names after normalizers may re-inject defaults
              applySavedAdminMenuNames(this.navItems, savedAdminMenu);
            } else {
              this.navItems = canonicalizeAdminMenu([], { userGroup });
              this.toggleShowUploadVideo();
              this.navItems = this.finalizeNavItems(this.navItems);
            }
            if (
              userProfile.isChannelSubAdmin === 1 &&
              userProfile.adminPermissions &&
              userProfile.adminPermissions.groupManagement === false
            ) {
              this.navItems = this.removeGroupManagementMenu(this.navItems);
            }
            if (this.navItems.length > 0) {
              this.initScrollbar();
            }

            if (
              userProfile.adminPermissions &&
              'permissions' in userProfile.adminPermissions &&
              userProfile.adminPermissions.permissions === 'messaging-only'
            ) {
              this.messagingOnly = true;
              const ids = [
                'separator1',
                'home',
                'dashboard',
                'separator2',
                'messages',
                'sendMessage',
                'sendTextSms',
                'messageList',
                'textSmsHistory',
                'separator3',
                'uploadContent',
              ];
              let filteredNavItems = this.navItems.filter((item) => ids.includes(item.id));
              if (!filteredNavItems.some((item) => item.id === 'uploadContent')) {
                const uploadItem = this.findUploadContentItem();
                if (uploadItem) {
                  filteredNavItems.push({ ...uploadItem });
                }
              }
              filteredNavItems = filteredNavItems.filter((item, index, self) => self.findIndex((t) => t.id === item.id) === index);
              this.navItems = filteredNavItems;
              if (this.navItems[this.navItems.length - 1].id === 'separator3') {
                this.navItems.pop();
              }
            }
          });
        });
      }
    },
    onCompanyChange(companyID) {
      var message = 'L O A D I N G ...';
      if (companyID) {
        let companyList = this.companyList;
        let company = Vue.lodash.filter(companyList, { companyID: companyID });
        Cookies.set('companyID', companyID);
        this.selectedCompany = companyID;

        this.$store.commit('company/SET_SELECTED_COMPANY', companyID);
        this.$store.commit('company/SET_SELECTED_COMPANY_DETAILS', company[0]);

        message = 'Loading resources of ' + company[0].name;
      } else {
        Cookies.remove('companyID');
        this.selectedCompany = companyID;

        this.$store.commit('company/SET_SELECTED_COMPANY', null);
        this.$store.commit('company/SET_SELECTED_COMPANY_DETAILS', {});
      }

      let company = this.$store.state.company.company;
      let faviconIcon = '/favicon.ico';

      if (this.selectedCompany == null && (company === null || company === '')) {
        faviconIcon = '/favicon.ico';
      } else {
        faviconIcon = company !== null ? company.favicon + '?=' + Math.random() : company.logo;
      }

      if (companyID == null) {
        Cookies.set('adminColor', '');
        this.iconColor = '';
      } else {
        if (Object.keys(company).length > 0) {
          if (company.hasOwnProperty('adminColor')) {
            Cookies.set('adminColor', company.adminColor.color_hex);
            this.iconColor = `color: ${company.adminColor.color_hex} !important`;
          } else {
            Cookies.set('adminColor', '');
            this.iconColor = '';
          }
        }
      }

      var favicon = document.querySelectorAll('.favicon');
      for (var i = 0; i < favicon.length; i++) {
        favicon[i].href = faviconIcon;
      }
      wrapNotification(this.$notify, NotificationTypes.Info, '', message, 10000);

      setTimeout(() => {
        this.$router.go();
      }, 2000);
    },
    showIdle() {
      let timerInterval;
      let username = this.$store.state.user.firstname;
      this.$swal
        .fire({
          position: 'center',
          imageUrl: this.staticUrl + '/img/idle.png',
          imageWidth: 150,
          title: 'Your session has expired',
          html: 'Hi <strong></strong> your being timed out due to inactivity. If you want to continue your session kindly click continue. <b></b>',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Continue',
          confirmButtonClass: 'btn btn-primary pr-5 pl-5',
          footer:
            '<div class="text-center"><p class="font-sm text-gray mb-0">Your session will automatically ends in <strong id="countoff"></strong> secs.</p></div>',
          buttonsStyling: false,
          allowOutsideClick: false,
          timer: 20000,
          onBeforeOpen: () => {
            this.$swal.getContent().querySelector('strong').textContent = username;
            timerInterval = setInterval(() => {
              this.$swal.getFooter().querySelector('#countoff').innerHTML = (this.$swal.getTimerLeft() / 1000).toFixed(0);
            }, 100);
          },
          onClose: () => {
            clearInterval(timerInterval);
          },
        })
        .then((result) => {
          if (result) {
            const { dismiss, value } = result;
            if (!value && dismiss === 'timer') {
              this.logout();
            }
          }
        });
    },
    logout: function () {
      this.$store.dispatch('auth/AUTH_LOGOUT').then(() => this.$router.push('/login'));
    },
    closeWarning() {
      Cookies.set('browser-warning', '0', { expires: 3 });
      this.$bvModal.hide('browser_warning');
    },
  },
  onIdle() {
    this.showIdle();
  },
};
</script>
<style lang="scss">
#companyID {
  color: #172b4d !important;
}
.navbar-brand {
  text-transform: uppercase;
  color: #fff !important;
  font-weight: bold;
  font-size: 18px;
}
.title-with-image {
  position: absolute;
  top: 20px;
  margin-left: 10px;
}
.sidenav .navbar-brand {
  padding: 0.5rem 1rem !important;
}
.custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
}
.hidden {
  display: none;
}
.sidebar-new-badge {
  display: inline-block;
  margin-left: 0.45rem;
  padding: 0.12rem 0.35rem;
  border-radius: 999px;
  background: #dc3545;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.03em;
  vertical-align: middle;
}
.ck-content {
  height: 300px;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-copy {
  cursor: copy;
}
.cursor-crosshair {
  cursor: crosshair;
}
.cursor-default {
  cursor: default;
}
.cursor-e-resize {
  cursor: e-resize;
}
.cursor-ew-resize {
  cursor: ew-resize;
}
.cursor-grab {
  cursor: -webkit-grab;
  cursor: grab;
}
.cursor-grabbing {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.cursor-help {
  cursor: help;
}
.cursor-move {
  cursor: move;
}
.cursor-n-resize {
  cursor: n-resize;
}
.cursor-ne-resize {
  cursor: ne-resize;
}
.cursor-nesw-resize {
  cursor: nesw-resize;
}
.cursor-ns-resize {
  cursor: ns-resize;
}
.cursor-nw-resize {
  cursor: nw-resize;
}
.cursor-nwse-resize {
  cursor: nwse-resize;
}
.cursor-no-drop {
  cursor: no-drop;
}
.cursor-none {
  cursor: none;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-progress {
  cursor: progress;
}
.cursor-row-resize {
  cursor: row-resize;
}
.cursor-s-resize {
  cursor: s-resize;
}
.cursor-se-resize {
  cursor: se-resize;
}
.cursor-sw-resize {
  cursor: sw-resize;
}
.cursor-text {
  cursor: text;
}
.cursor-w-resize {
  cursor: w-resize;
}
.cursor-wait {
  cursor: wait;
}
.cursor-zoom-in {
  cursor: zoom-in;
}
.cursor-zoom-out {
  cursor: zoom-out;
}
.custom-select {
  color: #525f7f !important;
}
.iconImg img {
  width: 20px;
  margin-right: 12px;
}
</style>
